// src/models/couponDetailsSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../reduxStore/store';

interface Coupon {
  title: string;
  points: string;
  end_date: string;
}

interface CurrentUserState {
  coupon: Coupon | null;
  loading: boolean;
  error: string | null;
}

const initialState: CurrentUserState = {
  coupon: null,
  loading: false,
  error: null,
};

interface ErrorResponse {
  message: string;
}

export const fetchCouponDetails = createAsyncThunk<any, string, { rejectValue: ErrorResponse, state: RootState }>(
  'couponDetails/fetchCouponDetails',
  async (couponId, thunkAPI) => {
    const token = localStorage.getItem('accessToken');
    console.log("Token for fetching data " + token);

    if (!token) {
      return thunkAPI.rejectWithValue({ message: 'No token available' });
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await axios.get(`${apiUrl}${shop_domain}/api/v1/coupons/${couponId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Single data " + JSON.stringify(response.data.data));
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return thunkAPI.rejectWithValue({ message: error.response.data.message || 'An error occurred' });
      }
      return thunkAPI.rejectWithValue({ message: 'An unknown error occurred' });
    }
  }
);

const couponDetailsSlice = createSlice({
  name: 'couponDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCouponDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCouponDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.coupon = action.payload;
      })
      .addCase(fetchCouponDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ? action.payload.message : 'Failed to fetch coupon details';
      });
  },
});

export default couponDetailsSlice.reducer;
